/**
 * 服务映射，主要用在src/api下面的接口中使用，作为接口前缀，以便访问网关服务。
 * 后续由其它服务名需要映射继续添加即可。
 */
import { ouchnSourceUrl, ouchnCustomUrl } from "@/utils/config";

let ouchnSource = ouchnSourceUrl || "/ouchn-source";
// let ouchnCustom = ouchnCustomUrl || "/ouchn-customapi";
// let ouchnCustom = ouchnCustomUrl || "/ouchn-customapi-lishiru"
// let ouchnCustom = ouchnCustomUrl || "/ouchn-customapi-xiemeng"
let ouchnCustom = ouchnCustomUrl || "/ouchn-customapi";
// let ouchnCustom = ouchnCustomUrl || "/ouchn-customapi-long"
export {
  ouchnSource,
  ouchnCustom,
  // ...
};
